<template>
  <footer>
    <div class="content-line-inner">
      <div class="footer-wrapper">
        <div class="footer-area footer-left">
          <div class="footer-address">
            <p class="footer-address-heading">
              <span class="footer-address-medau">Medau</span>
              Therapy Services
            </p>
            <div class="footer-p-wrapper" v-html="cleanedFooterData.Adresse" />
          </div>
          <div class="footer-contact">
            <div class="footer-contact-line">
              <div class="footer-contact-line-title">Telefon:</div>
              <a class="footer-contact-line-content" href="tel:+49956123510">
                {{ cleanedFooterData.Telefon }}
              </a>
            </div>
            <div class="footer-contact-line">
              <div class="footer-contact-line-title">Fax:</div>
              <div class="footer-contact-line-content">
                {{ cleanedFooterData.Fax }}
              </div>
            </div>
            <div class="footer-contact-line">
              <div class="footer-contact-line-title">E-Mail:</div>
              <div class="footer-contact-line-content">
                {{ cleanedFooterData.EMail }}
              </div>
            </div>
          </div>
          <div class="footer-legal">
            <p>
              <router-link to="/seiten/impressum">Impressum</router-link>
            </p>
            <p>
              <router-link to="/seiten/datenschutz">Datenschutz</router-link>
            </p>
          </div>
        </div>
        <div class="footer-area footer-center">
          <div class="footer-standorte" v-if="standorte&&Array.isArray(standorte)">
            <div class="footer-standort" v-for="standort in standorte">
              <div class="footer-standort-title">
                <div class="footer-standort-field">
                  <span>Medau</span>{{ field }}
                </div>
                <div class="footer-standort-location">{{ standort.attributes.Ort }}</div>
              </div>
              <a class="footer-standort-phone" :href="'tel:'+standort.attributes.Telefon">
                {{ standort.attributes.Telefon }}
              </a>
            </div>
          </div>
        </div>
        <div class="footer-area footer-right">
          <img :src="getImage('logo_bunt.svg')" alt="Medau-Logo" class="footer-right-logo"
               @click="$router.push('/seiten/MEDAU-Gruppe')" style="cursor: pointer;">
          <div class="footer-right-bottom">
            <div class="footer-social-heading">Mehr erleben?</div>
            <a href="//facebook.com/MEDAUtherapie" target="_blank">
              <img :src="getImage('facebook.png')"
                   class="footer-social-facebook footer-social-image"
                   alt="Zu Facebook">
            </a>
            <a href="//www.instagram.com/medautherapie/" target="_blank">
              <img :src="getImage('instagram.png')"
                   class="footer-social-instagram footer-social-image"
                   alt="Zu Instagram">
            </a><br />
            #MEDAUmehralsmanglaubt<br />
            <a href="//www.medau-schule.de">www.medau-schule.de</a><br />
            <a href="//www.medau-therapie.de">www.medau-therapie.de</a>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      standorte: null,
      footerData: null,
    };
  },
  props: [
    "field",
  ],
  computed: {
    cleanedFooterData() {
      if(this.footerData) {
        return this.footerData;
      }
      return {
        Telefon: '+49 (0)9561 / 2351-0',
        Fax: '+49 (0)9561 / 2351´-34',
        EMail: 'info@medau-ts.de',
        Adresse: '<p>Schloss Hohenfels</p><p>96450 Coburg</p>'
      }
    }
  },
  methods: {
    loadData() {
      this.standorte = null;
      if(this.field) {
        this.apiRequest('/locations?populate[]=Leitung&populate[]=Angebote&populate[]=Oeffnungszeiten' +
            '&populate[]=Bilder&filters[Bereich][Titel][$eq]=' + this.field)
            .then(cnt => {
              this.standorte = cnt.data || null;
            })
            .catch(() => this.standorte = false);
      }
      this.apiRequest('/footer')
          .then(cnt => {
            this.footerData = cnt?.data?.attributes || null;
          })
          .catch(() => this.footerData = false);
    }
  },
  mounted() {
    this.loadData();
  }
}
</script>